import { API } from "@/lib/api";
import { RecurlyPlan } from "@/lib/recurly";
import { BillingCheckoutBody, BillingGetSubscriptionResponse, BillingUpdatePaymentMethodBody, CancelReasonsBody, CancelReasonsResponse, ChangeSubscriptionBody, ChangeSubscriptionResponse, InvoiceDetail, PaymentMethodDetail, SubscriptionChangePreviewResponse, SubscriptionDetail, SubscriptionPlan } from "@boxem/core-api-schema";

export function checkout(payload: BillingCheckoutBody) {
  return API.post("/billing/checkout", payload, null);
}

export function getSubscriptions(): Promise<BillingGetSubscriptionResponse> {
  return API.get("/billing/subscriptions");
}

export function getSubscriptionsV2(): Promise<SubscriptionDetail> {
  return API.get("/billing/v2/subscriptions");
}

export function getPaymentDetails(): Promise<PaymentMethodDetail> {
  return API.get("/billing/payment-detail");
}

export function getPlan(planCode?: string): Promise<RecurlyPlan> {
  return API.get(`/billing/plans/${planCode || "standard-launch-monthly-inapp"}`)
}

export function changePlanPreview(subscriptionId: string, planCode?: string): Promise<SubscriptionChangePreviewResponse> {
  const payload: ChangeSubscriptionBody = {
    subscriptionId: subscriptionId,
  }
  return API.post(`/billing/plans/${planCode || "standard-launch-monthly-inapp"}/preview`, payload);
}

export function changePlan(subscriptionId: string, planCode: string, planName: string): Promise<ChangeSubscriptionResponse> {
  const payload: ChangeSubscriptionBody = {
    subscriptionId: subscriptionId,
    newPlanName: planName
  }
  return API.post(`/billing/plans/${planCode}`, payload);
}

export function getInvoiceDetail(invoiceId: string): Promise<InvoiceDetail> {
  return API.get(`/billing/invoice/${invoiceId}`);
}

export function updatePaymentMethod(payload: BillingUpdatePaymentMethodBody): Promise<PaymentMethodDetail> {
  return API.post("/billing/update-payment-method", payload);
}

export function cancelSubscription(payload: CancelReasonsBody): Promise<CancelReasonsResponse> {
  return API.post("/billing/cancel", payload);
}

export function downloadInvoicePdf(invoiceId: string): Promise<Blob> {
  return API.get(`/billing/invoice/${invoiceId}/download`);
}

